import { useState, useEffect } from 'react';

const usePageLoader = () => {
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // Wait one tick after mount so the page renders before hiding loader
    const id = setTimeout(() => setLoading(false), 300);
    return () => clearTimeout(id);
  }, []);

  return loading;
};

export default usePageLoader;